<!-- @format -->
<works-confirm-tag>
  <style>
    .modal__content_inner {
      max-height: 80vh;
      overflow-y: auto;
    }
  </style>

  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h3 class="modal_heading margin-spacing-3_bottom">
          {props.title}を削除します。
        </h3>

        <div class="wrap_button">
          <div
            class="button button-secondary-large button-border margin-spacing-1_right"
            type="button"
            value="削除しない"
            onclick="{ props.onClose }"
          >
            削除しない
          </div>
          <div
            class="button button-secondary-large"
            type="button"
            value="削除る"
            onclick="{ props.onSubmit }"
          >
            削除する
          </div>
        </div>
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>

  <script>
    import base from "./modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
    };
  </script>
</works-confirm-tag>
